'use client';

import { useEffect, useState } from 'react';

import Link from 'next/link';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

function PrefetchLinks() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div aria-hidden="true" className="hidden">
      <Link href="/dashboard" prefetch={true}>
        <span />
      </Link>
      <Link href="/auth/reset-password" prefetch={true}>
        <span />
      </Link>
    </div>
  );
}

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? ''}>
      <div className="bg-gray-100">
        <PrefetchLinks />
        {children}
      </div>
    </GoogleReCaptchaProvider>
  );
}
